<template>
    <v-card class="statisticsDonutComponent pa-3 pt-0">
        <v-card-title>
            {{ $t("events_evolution") }}
        </v-card-title>
        <v-card-text>
            <v-skeleton-loader v-if="stats === null" type="article"></v-skeleton-loader>

            <div v-else-if="graphData.datasets.length && graphData.labels.length">
                <LineComponent :dataSet="graphData" />
            </div>
            
            <v-alert class="mb-0" border="left" color="info" v-else text>
                {{ $t("emptyDataMessage") }}
            </v-alert>
        </v-card-text>
    </v-card>
</template>

<script>
import LineComponent from '@/components/graphs/LineComponent';

export default {
    name: "statisticsDonutComponent",
    props: ["stats"],
    components: { LineComponent },
    data() {
        return {
            graphData: {},
        }
    },
    watch: {
        stats: {
            handler() {
                this.generateGraphData();
            },
            deep: true,
            immediate: true,
        }
    },
    methods: {
        generateGraphData() {
            if(this.stats !== null) {
                this.graphData = { labels: [], datasets: [] };

                Object.keys(this.stats).forEach((date) => {
                    const months = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"];
                    const [year, month, day] = date.split("-");
                    this.graphData.labels.push(`${day} ${months[parseInt(month, 10) - 1]} ${year}`);

                    Object.keys(this.stats[date]).forEach((event) => {
                        let dataset = this.graphData.datasets.find(ds => ds.label === "event_" + event);
                        if(!dataset) {
                            dataset = {
                                label: "event_" + event,
                                data: [],
                                borderColor: this.stats[date][event].color,
                                backgroundColor: this.stats[date][event].color + '4D',
                                fill: true,
                                lineTension: 0,
                                pointStyle: 'line'
                            };
                            this.graphData.datasets.push(dataset);
                        }
                        dataset.data.push(this.stats[date][event].count);
                    });
                });
            }
        },
    },
}
</script>